
import { BasicModel } from "@goodgamestudios/core";
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextValide } from "@goodgamestudios/core";

import { SFConstants } from "../../constants/SFConstants";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2LostPasswordDialog extends Poker2Dialog {
    public static NAME: string = "Poker2LostPasswordDialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.lostPassDialog.btn_yes.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        this.lostPassDialog.btn_no.label = Poker2Model.languageData.getTextById("generic_btn_goback");
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.lostPassDialog.txt_title, Poker2Model.languageData.getTextById("generic_login_lostpassword_title"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.lostPassDialog.txt_copy, Poker2Model.languageData.getTextById("generic_login_lostpassword_copy"), 7);
        this.lostPassDialog.txt_name.inputField.text = "";
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.lostPassDialog.btn_yes:
                if (!TextValide.isEmailString(this.lostPassDialog.txt_name.inputField.text))
                    this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_warning"), Poker2Model.languageData.getTextById("generic_register_error_invalidemail")));
                else if (this.lostPassDialog.txt_name.inputField.text.length > 0 && TextValide.isSmartFoxValide(this.lostPassDialog.txt_name.inputField.text)) {
                    this.sendLostPassword();
                    this.hide();
                }
                else
                    this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_warning"), Poker2Model.languageData.getTextById("generic_register_email_copy")));
                break;
            case this.lostPassDialog.btn_no:
            case this.lostPassDialog.btn_close:
                this.hide();
                break;
        }
    }

    public hide() {
        super.hide();
        this.controller.dispatchEvent(new Poker2DialogEvent(Poker2DialogEvent.ON_HIDE,["Poker2LostPasswordDialog"]));
    }

    private sendLostPassword(): void {
        var paramObject: any = { mail: this.lostPassDialog.txt_name.inputField.text, lang: this.env.currentCountryLanguageCode };
        BasicModel.smartfoxClient.sendMessage("llp", [JSON.stringify(paramObject)]);
    }

    protected get lostPassDialog(): Library.PokerInterface.PokerLostPassword {
        return this.disp as Library.PokerInterface.PokerLostPassword;
    }
}
import { Poker2WarningDialog } from "./Poker2WarningDialog";
import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";

